var _radialGradient, _rect, _rect2, _linearGradient, _rect3, _linearGradient2, _rect4, _path, _path2, _linearGradient3, _rect5, _linearGradient4, _path3, _linearGradient5, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FullToolStorageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "8BtECwQX0yXixXXYiYlOGa",
    cx: 33.596,
    cy: 16.936,
    r: 7.383,
    gradientTransform: "matrix(1 0 0 .9285 0 .999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#787f85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#7a8187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#90989f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#9da5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a1aab3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 12,
    x: 31,
    y: 18,
    fill: "url(#8BtECwQX0yXixXXYiYlOGa)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 5,
    x: 5,
    y: 34,
    fill: "#ab560c"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8BtECwQX0yXixXXYiYlOGb",
    x1: 5,
    x2: 42,
    y1: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97218"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 6,
    x: 5,
    y: 29,
    fill: "url(#8BtECwQX0yXixXXYiYlOGb)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8BtECwQX0yXixXXYiYlOGc",
    x1: 5,
    x2: 42,
    y1: 41,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97218"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 6,
    x: 5,
    y: 38,
    fill: "url(#8BtECwQX0yXixXXYiYlOGc)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ad570d",
    d: "M5.5,45L5.5,45C4.672,45,4,44.328,4,43.5v-19C4,23.672,4.672,23,5.5,23h0C6.328,23,7,23.672,7,24.5 v19C7,44.328,6.328,45,5.5,45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad570d",
    d: "M42.5,45L42.5,45c-0.828,0-1.5-0.672-1.5-1.5v-19c0-0.828,0.672-1.5,1.5-1.5l0,0 c0.828,0,1.5,0.672,1.5,1.5v19C44,44.328,43.328,45,42.5,45z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8BtECwQX0yXixXXYiYlOGd",
    x1: 14.818,
    x2: 15.182,
    y1: 16.886,
    y2: 26.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#ffd04f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 15,
    x: 12,
    y: 14,
    fill: "url(#8BtECwQX0yXixXXYiYlOGd)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8BtECwQX0yXixXXYiYlOGe",
    x1: 13.106,
    x2: 17.614,
    y1: 8.992,
    y2: 17.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#8BtECwQX0yXixXXYiYlOGe)",
    d: "M22.926,16H8.074C7.481,16,7,15.519,7,14.926V9.074C7,8.481,7.481,8,8.074,8h10.549 c0.244,0,0.481,0.083,0.671,0.235l4.302,3.442C23.852,11.881,24,12.19,24,12.516v2.409C24,15.519,23.519,16,22.926,16z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8BtECwQX0yXixXXYiYlOGf",
    x1: 30.901,
    x2: 36.648,
    y1: 10.383,
    y2: 19.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#8BtECwQX0yXixXXYiYlOGf)",
    d: "M36,9.311l0,4.046c0,1.308-0.941,2.499-2.242,2.63C32.261,16.137,31,14.966,31,13.5V9.311 c0-0.386-0.422-0.63-0.756-0.436c-1.973,1.145-3.289,3.296-3.242,5.752c0.066,3.438,2.964,6.322,6.402,6.372 C37.038,21.052,40,18.122,40,14.5c0-2.401-1.303-4.497-3.239-5.623C36.425,8.682,36,8.923,36,9.311z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FullToolStorageBox);
export default __webpack_public_path__ + "static/media/icons8-full-tool-storage-box.cc38e10ad63c39f89811a010cd282460.svg";
export { ForwardRef as ReactComponent };